import { prop } from "../../decorators/property";
import { AlertsJurisdictionModel } from "./alerts-jurisdiction";
import { AlertsCourtModel } from "./alerts-court";
import { AlertsSearchModel } from "./alerts-search";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AuthorizationModel } from "../../authentication/models/authorization-model";
import { AppSettings } from "../../app-settings";
import { AlertsReportModel } from "./alerts-report";

@backboneModelProperties({
    relations: [{
        type: Backbone.Many,
        key: "JurisdictionAlerts",
        relatedModel: AlertsJurisdictionModel
    },
    {
        type: Backbone.Many,
        key: "CourtAlerts",
        relatedModel: AlertsCourtModel
    },
    {
        type: Backbone.Many,
        key: "SearchAlerts",
        relatedModel: AlertsSearchModel
    },
    {
        type: Backbone.Many,
        key: "ReportAlerts",
        relatedModel: AlertsReportModel
    }],
    defaults: {
        JurisdictionAlerts: [],
        CourtAlerts: [],
        SearchAlerts: [],
        ReportAlerts: []
    }
})
export class AlertsModel extends Backbone.AssociatedModel {
    @prop() public Section: string;
    @prop() public JurisdictionAlerts: Backbone.Collection<AlertsJurisdictionModel>;
    @prop() public CourtAlerts: Backbone.Collection<AlertsCourtModel>;
    @prop() public SearchAlerts: Backbone.Collection<AlertsSearchModel>;
    @prop() public ReportAlerts: Backbone.Collection<AlertsReportModel>;
    @prop() public Loaded = false;

    constructor(options?) {
        super(options);
    }

    public fetchSearchData(): Promise<any> {
        this.Loaded = false;
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                type: "GET",
                url: `${AppSettings.ApiUrlPrefix}alerts/searches`,
                cache: false
            }).done((response) => {
                this.Loaded = true;
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    public fetchJurisdictionData(): Promise<any> {
        this.Loaded = false;
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                type: "GET",
                url: `${AppSettings.ApiUrlPrefix}alerts/jurisdictions`,
                cache: false
            }).done((response) => {
                this.Loaded = true;
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    public fetchCourtData(): Promise<any> {
        this.Loaded = false;
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                type: "GET",
                url: `${AppSettings.ApiUrlPrefix}alerts/courts`,
                cache: false
            }).done((response) => {
                this.Loaded = true;
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    public fetchReportData(): Promise<any> {
        this.Loaded = false;
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                type: "GET",
                url: `${AppSettings.ApiUrlPrefix}alerts/reports`,
                cache: false
            }).done((response) => {
                this.Loaded = true;
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/alerts.ts